import { render, staticRenderFns } from "./growthBottom.vue?vue&type=template&id=2a41030e&scoped=true"
import script from "./growthBottom.vue?vue&type=script&lang=js"
export * from "./growthBottom.vue?vue&type=script&lang=js"
import style0 from "./growthBottom.vue?vue&type=style&index=0&id=2a41030e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a41030e",
  null
  
)

export default component.exports